import { createApi } from "@reduxjs/toolkit/query/react";
import { loginBaseQuery } from "./baseQuery";

export const utilityAPI = createApi({
  reducerPath: "utilityAPI",
  baseQuery: loginBaseQuery,
  endpoints: (builder) => ({
    getLocations: builder.query({
      query: (params) => ({
        url: "/api/utility/locations/?all=True",
        method: "GET",
        params,
      }),
    }),
  }),
});

export const { useGetLocationsQuery } = utilityAPI;

export default utilityAPI;
